// Copyright (c) Docugami, Inc. All rights reserved.

import { Stack } from "@fluentui/react";
import { ChunkToolbar } from 'components/sdv/ChunkToolbar';
import { ToolType } from 'components/sdv/ToolbarItem';
import { Engine } from 'sdv/engine/Engine';
import { PropertiesButton } from './PropertiesButton';
import styled from 'styled-components';

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;

export interface DocumentMenuProps {
    documentId: string;
    engine: Engine | null;
    searchBar: JSX.Element;
    canLink: boolean;
    onLink: () => void;
    excludedTools?: ToolType[];
    isLinking: boolean;
    setPropertiesHidden: (hidden: boolean) => void;
    propertiesHidden: boolean;
    editText: () => void;
    textEditDisabled: boolean;
    sdvCanvas?: HTMLElement;
}

export const DocumentMenu = (props: DocumentMenuProps): JSX.Element => {
    return (
        <div className="documentMenu">
            <Stack horizontal verticalAlign="center" horizontalAlign="center" styles={{ root: { height: "100%", justifyContent: "space-between" } }} tokens={{ childrenGap: '20px' }}>
                <ButtonContainer>
                    <ChunkToolbar sdvCanvas={props.sdvCanvas} editText={props.editText} textEditDisabled={props.textEditDisabled} engine={props.engine} documentId={props.documentId} canLink={props.canLink} onLink={props.onLink} excludedTools={props.excludedTools} isLinking={props.isLinking} />
                    <PropertiesButton onClick={() => props.setPropertiesHidden(!props.propertiesHidden)} hidden={props.propertiesHidden} />
                </ButtonContainer>
                {props.searchBar}
            </Stack>
        </div>
    );
}
